import { SvgIcon , SvgIconProps} from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterInsertEmojiIconProps extends SvgIconProps {}
/**
 * component used to display twitter insert emoji icon in twitter interaction
 * @param props - CcfTwitterInsertEmojiIconProps
 * @example - <CcfTwitterInsertEmojiIcon />
 * @returns SVG of twitter insert emoji icon in twitter interaction
 */
export function CcfTwitterInsertEmojiIcon(props: CcfTwitterInsertEmojiIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_insert_emoji" clip-path="url(#clip-ic_insert_emoji)">
        <path id="emoji" d="M13.434,9.916a.88.88,0,1,0-.88-.88A.88.88,0,0,0,13.434,9.916Zm-5.277,0a.88.88,0,1,0-.88-.88A.88.88,0,0,0,8.157,9.916ZM10.8,2a8.8,8.8,0,1,0,8.8,8.8A8.8,8.8,0,0,0,10.8,2Zm0,15.831A7.036,7.036,0,1,1,17.831,10.8,7.036,7.036,0,0,1,10.8,17.831Zm3.764-6.262a.88.88,0,0,0-1.231-.141,2.445,2.445,0,0,0-.774,1.126H9.344A2.471,2.471,0,0,0,8.57,11.4.882.882,0,0,0,7.5,12.8a.88.88,0,0,1,.22.633.959.959,0,0,1-.22.633.88.88,0,1,0,1.1,1.372,2.542,2.542,0,0,0,.739-1.126h3.219a2.392,2.392,0,0,0,.783,1.152.88.88,0,0,0,1.064-1.4.88.88,0,0,1-.22-.633.959.959,0,0,1,.22-.633A.88.88,0,0,0,14.559,11.569Z" transform="translate(-1 -1)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterInsertEmojiIcon;
